export default __webpack_public_path__ + "static/smp-meshery-6f64e8445e9156f17ba3eca28c081ab7.webp";